
const digest = '15a40320ffc082537fa328cc31ca2e8520035f6aa01778f31275e2cde4ff86fc';
const classes = {"group":"_group_1bg2h_1","title":"_title_1bg2h_5","container":"_container_1bg2h_15","subtitle":"_subtitle_1bg2h_27","checkbox":"_checkbox_1bg2h_33","textfield":"_textfield_1bg2h_33","space":"_space_1bg2h_37"};
const css = `._group_1bg2h_1 {
  display: flex;
  flex-direction: column;
}
._group_1bg2h_1 ._title_1bg2h_5 {
  font-weight: 500;
  font-size: 16px;
  background-color: #eaedf3;
  padding: 8px 12px;
  border-radius: 5px;
  color: #000000;
  border-left: 10px solid #1d65d8;
}

._container_1bg2h_15 {
  display: flex;
  gap: 8px;
}

._title_1bg2h_5 {
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  padding: 0 12px;
}

._subtitle_1bg2h_27 {
  font-size: 14px;
  color: #000000;
  padding: 0 12px;
}

._checkbox_1bg2h_33, ._textfield_1bg2h_33 {
  padding: 0 12px;
}

._space_1bg2h_37 {
  height: 25px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  